import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import './index.css';
import './common_styles.css';
import * as serviceWorker from './serviceWorker';
import { store } from './presentation/redux/store/store';
import App from './App.js';
import packageJson from '../package.json';

console.log(
  `%c POS v${packageJson.version}`,
  'background: #111827; color: #10B981; padding: 4px 6px; border-radius: 4px 0 0 4px; font-weight: bold;',
);


ReactDOM.render(
  <React.StrictMode>

    <Provider store={store}>
      <App />
    </Provider>

  </React.StrictMode>,
  document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
